import { baseService } from "src/store/base.store";
import { executeQuery } from "src/store";
import { rewardsRepository } from "./repositories/rewards.repository";
import { Reward } from "./types/reward.entity";
import { callFunctionSafe } from "src/firebase/functions";

export const rewardsService = baseService.injectEndpoints({
  endpoints: (builder) => ({
    getRewards: builder.query<Reward[], { where?: any; offset?: string }>({
      queryFn: async ({ where = {}, offset }) =>
        executeQuery(async () => {
          const rewards = await rewardsRepository.find({
            where,
            offset,
            orderBy: ["createdAt", "desc"],
          });
          return rewards;
        }),
      providesTags: ["Rewards"],
    }),
    getRewardById: builder.query<Reward | null, string>({
      queryFn: async (id) =>
        executeQuery(async () => {
          const reward = await rewardsRepository.findById(id);
          return reward;
        }),
      providesTags: ["Rewards"],
    }),
    countRewards: builder.query<number, void>({
      queryFn: async () => executeQuery(() => rewardsRepository.count()),
    }),
    createReward: builder.mutation<void, any>({
      queryFn: async (payload) => callFunctionSafe("createReward", payload),
      invalidatesTags: ["Rewards"],
    }),
    updateReward: builder.mutation<void, any>({
      queryFn: async (payload) => callFunctionSafe("updateReward", payload),
      invalidatesTags: ["Rewards"],
    }),
  }),
});

export const {
  useGetRewardsQuery,
  useGetRewardByIdQuery,
  useCountRewardsQuery,
  useCreateRewardMutation,
  useUpdateRewardMutation,
} = rewardsService;
